@if (checkIfProductIsAvailable() && !productInfo()?.flu) {
  <div [class.w-100]="fullWidthButton()">
    @if (productInfo()?.stockAvailableStatus === StockAvailableStatus.LIMITED && !productInfo().allowLimitedStockProducts) {
      <span class="c-text color-error" disabled>{{ 'plp.unavailableToOrderText' | cxTranslate }}</span>
    }

    @if (checkIfUnavailableToOrder()) {
      <button class="c-button c-button--primary" [class.w-100]="fullWidthButton()" disabled>
        {{ 'plp.unavailableToOrder' | cxTranslate }}
      </button>
    }

    <!-- Add to cart buttons -->
    <ng-template #popOverLimited>
      <div class="c-popover-black">
        @if (productInfo()?.stockAvailableStatus === StockAvailableStatus.LOW) {
          <p>
            Low stock<br/>
            <span>Stock is Limited</span>
          </p>
        }

        @if (productInfo()?.stockAvailableStatus === StockAvailableStatus.NORMAL) {
          <p>
            Normal stock<br/>
            <span>Stock is available</span>
          </p>
        }

        @if (productInfo()?.stockAvailableStatus === StockAvailableStatus.LIMITED && !productInfo()?.allowLimitedStockProducts) {
          <p>
            Stock Unavailable<br/>
            <span>Please call Customer Support</span>
          </p>
        }

        @if (productInfo()?.stockAvailableStatus === StockAvailableStatus.LIMITED && productInfo()?.allowLimitedStockProducts) {
          <p>
            Stock is very Limited <br/>
          </p>
        }
      </div>
    </ng-template>

    <ng-template #addToCartNotice>
      <section class="header-modal checkout-modal modal-selector modal-with-select">
        <section class="modal-dialog d-flex">
          <div class="modal-content">
            <div class="close">
              <em class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mr-3 mt-4" (click)="modal.dismissAll()"></em>
            </div>
            <section class="modal-body px-4">
              Ao adicionar este produto ao carrinho usando o contrato
              @if (productInfo()?.conditions?.length == 1) {
                <span>{{ productInfo()?.conditions[0]?.contractId }} ({{ productInfo()?.conditions[0]?.contractName }})</span>
              } @else {
                <span>{{ contractSelectedId() }} ({{ contractSelected()?.contractName }})</span>
              },
              você pode continuar adicionando produtos que estão contemplados no mesmo contrato.
              Se deseja adicionar produtos usando um contrato diferente, limpe o carrinho atual
              e selecione o produto do contrato desejado
            </section>
            <section class="modal-footer justify-content-start">
              <button type="button" class="c-button c-button--secondary ml-3" (click)="modal.dismissAll()">
                {{ 'account.cancel' | cxTranslate }}
              </button>
              <button (click)="addToCart(productInfo()?.code); modal.dismissAll();" class="c-button c-button--primary ml-3">
                {{ 'account.continue' | cxTranslate }}
              </button>
            </section>
          </div>
        </section>
      </section>
    </ng-template>

    <button
      class="c-button c-button--primary"
      [class.w-100]="fullWidthButton()"
      *ngIf="checkIfProductCanBeAddedToTheCart()"
      triggers="manual"
      #p2="ngbPopover"
      placement="bottom"
      popoverClass="pdp-itemsuccess-msg"
      [closeDelay]="500"
      [ngbPopover]="popTitleSuccess"
      [disabled]="!enableBtn()"
      id="prod-{{ productInfo()?.code }}"
      (click)="openModal(addToCartNotice, productInfo()?.code)">
      {{ 'addToCartItems.addCart' | cxTranslate }}
    </button>

    <!-- Private Button -->
    <ng-container *ngIf="checkIfProductCanBeAddedToTheCartWithPrivate()">
      <button
        class="c-button c-button--primary"
        [class.w-100]="fullWidthButton()"
        [ngbPopover]="popTitleSuccess"
        placement="bottom"
        triggers="manual"
        #p2="ngbPopover"
        popoverClass="pdp-itemsuccess-msg"
        [closeDelay]="500"
        (click)="addToCart(productInfo()?.code)">
        {{ 'addToCartItems.addCart' | cxTranslate }}
      </button>
    </ng-container>
  </div>
}

@if (checkIfProductIsAvailable()) {
  <div class="sap-allocation-area u-hide-if-empty">
    <div *ngIf="productInfo()?.sapAllocation === true">
      <strong class="prod-allocation">{{ 'plp.productAllocation' | cxTranslate }}</strong>
      <p class="allocation-p">{{ 'plp.allocationDetails' | cxTranslate }}</p>
    </div>
  </div>
}

@if (productInfo()?.discontinued || !productInfo()?.available) {
  <section>
    @if (productInfo()?.discontinued && productInfo()?.available) {
      <section>
        <p class="text-center product-discontinued-txt1">{{ 'plp.discontinued' | cxTranslate }}</p>
      </section>
    }

    @if (productInfo()?.discontinued && !productInfo()?.available) {
      <section>
        <p class="text-center product-discontinued-txt1">{{ 'plp.discontinued' | cxTranslate }}</p>
      </section>
    }

    @if (!productInfo()?.discontinued && !productInfo()?.available) {
      <section>
        <section class="text-center1">
          <strong class="text-center product-discontinued-txt1" *ngIf="productInfo()?.availabilityText">
            {{ productInfo()?.availabilityText }}
          </strong>
          <strong class="text-center product-discontinued-txt1" *ngIf="!productInfo()?.availabilityText">
            {{ 'plp.productUnavailable' | cxTranslate }}
          </strong>
        </section>
      </section>
    }
  </section>
}

<section class="added-success-container">
  <ng-template #popTitleSuccess>
    <div class="cart-value-added">
      <img
        src="icons/confirmation-positive-green.png"
        class="positive-green-icon"
        alt="success"/>
      <span
        class="confirmation-itemsadded"
        *ngIf="!flagRemoved; else NA"
      >{{ itemAddedQuantity }}
        {{ 'addToCartItems.addEntrySuccess' | cxTranslate }}</span
      >
      <ng-template #NA>
                  <span class="confirmation-itemsadded">
                    {{ itemAddedQuantity }}
                    {{ ProductUtils.getUnitTranslation(selectedChannel()) }}
                    {{ 'addToCartItems.updateEntrySuccess' | cxTranslate }}</span>
      </ng-template>
    </div>
  </ng-template>
</section>

@if (productInfo()?.flu && checkIfProductIsAvailable()) {
  <section class="flu-class">
    <section>
      <p class="contact-info">
        {{ 'plp.productAllocationInfo1' | cxTranslate }}
        <strong> {{ 'plp.emergencycontact' | cxTranslate }}</strong>
        {{ 'plp.productAllocationInfo2' | cxTranslate }}
      </p>
    </section>
    <section class="col-md-4 col-sm-4 col-xs-12 button-area flu-button-area">
      <button
        class="c-button c-button--primary login-btn ml10 flu-button"
        data-di-id="di-id-2fea5a72-b2e23002 "
        [ngbPopover]="popTitleSuccess"
        placement="bottom"
        triggers="manual"
        #p2="ngbPopover"
        (click)="addToCart(productInfo().code)">
        <em *ngIf="buttonName === 'Reserve now'" class="fa fa-calendar" aria-hidden="true"></em>
        <span *ngIf="buttonName === 'Add to cart'">{{ 'addToCartItems.addCart' | cxTranslate }}</span>
        <span *ngIf="buttonName === 'Login to order'">{{ 'addToCartItems.loginToOrder' | cxTranslate }}</span>
        <span class="reserve-now-button" *ngIf="buttonName === 'Reserve now'">{{ 'addToCartItems.reserveNow' | cxTranslate }}</span>
      </button>
    </section>
  </section>
}

<section>
  <section *ngIf="userDetails === undefined" class="col-md-4 col-sm-4 col-xs-12 button-area">
    <button type="button" class="c-button c-button--primary my-4" (click)="goToLogin()">
      <span *ngIf="buttonName === 'Add to cart'">{{ 'addToCartItems.addCart' | cxTranslate }}</span>
      <span *ngIf="buttonName === 'Login to order'">{{ 'addToCartItems.loginToOrder' | cxTranslate }}</span>
      <span class="reserve-now-button" *ngIf="buttonName === 'Reserve now'">{{ 'addToCartItems.reserveNow' | cxTranslate }}</span>
    </button>
  </section>

  <section *ngIf="userDetails !== undefined">
    <section *ngIf="!productInfo()?.discontinued && productInfo()?.available"
             class="products-accordion clear-fix pt2 u-hide-if-empty-child">
      <section class="panel-group">
        <section class="panel panel-default" *ngIf="productInfo()?.volumePrices?.length > 0">
          <section class="panel-heading panel-endborder">
            <section class="first-level-acc">
              <label>
                <img src="icons/price-master.svg" class="accordion-img" alt=""/>
                {{ 'plp.volumePricing' | cxTranslate }}
              </label>
              <span
                data-toggle="collapse"
                data-parent="#accordion"
                href="#pdp-list1"
                class="acc-plus-icon fa"
                aria-expanded="panelVolumeExpanded"
                (click)="panelVolumeExpanded = !panelVolumeExpanded"
                [ngClass]="panelVolumeExpanded ? 'fa-minus' : 'fa-plus collapsed'">
                      </span>
            </section>
          </section>
          <section
            id="pdp-list1"
            class="panel-collapse collapse"
            aria-expanded="panelVolumeExpanded"
            (click)="panelVolumeExpanded = !panelVolumeExpanded"
            [ngClass]="panelVolumeExpanded ? 'in' : ''">
            <section class="panel-body">
              <section id="vol-price-pdp">
                <table aria-describedby="pdpTable" class="c-table c-table--branded mt-4">
                  <th></th>
                  <tbody>
                  <tr *ngFor="let prices of productInfo()?.volumePrices;let i = index">
                    <td>{{ prices?.minQuantity }} - {{ prices?.maxQuantity }}{{ 'plp.units' | cxTranslate }}:</td>
                    <td>{{ prices?.value | localCurrency }}</td>
                    <td>
                        <span *ngIf="i > 0">
                          <span class="text-success text-fixed-legal text-uppercase">{{ 'plp.save' | cxTranslate }}</span>&nbsp;
                          <span class="font-bold">
                            {{ productInfo()?.volumePrices[0].value - productInfo()?.volumePrices[i].value | localCurrency }}</span>
                        </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  </section>
  <section class="products-accordion clear-fix pt2 u-hide-if-empty-child">
    <section class="panel-group">
      <!-- update2 -->
      <section class="panel panel-default" *ngIf="productInfo()?.productUpdates">
        <section class="panel-heading">
          <section class="first-level-acc">
            <label>
              <img src="icons/info.png " class="accordion-img" alt=" "/>
              {{ 'plp.productUpdate' | cxTranslate }}
            </label>
            <span
              data-toggle="collapse "
              data-parent="#accordion "
              href="#pdp-list3 "
              class="acc-plus-icon fa"
              aria-expanded="panelProductExpanded "
              (click)="panelProductExpanded = !panelProductExpanded"
              [ngClass]="
                        panelProductExpanded ? 'fa-minus' : 'fa-plus collapsed'
                      "></span>
          </section>
        </section>
        <section
          id="pdp-list3 "
          class="panel-collapse collapse"
          aria-expanded="panelProductExpanded "
          (click)="panelProductExpanded = !panelProductExpanded"
          [ngClass]="panelProductExpanded ? 'in' : ''">
          <section class="panel-body productupdate-p">
            {{ productInfo()?.productUpdates }}
          </section>
        </section>
      </section>
    </section>
  </section>
</section>
